export const APP_NAME = 'roleAssumption';
